module.exports = __webpack_public_path__ + "img/selected_regular_retrofit.2b4a16be.svg";